import { render, staticRenderFns } from "./DetailsBallastFixation.vue?vue&type=template&id=3aad7f0b&scoped=true&"
import script from "./DetailsBallastFixation.vue?vue&type=script&lang=js&"
export * from "./DetailsBallastFixation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aad7f0b",
  null
  
)

export default component.exports